import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MicrophoneService {
  private micStream: MediaStream | null = null;

  setStream(stream: MediaStream) {
    this.micStream = stream;
  }

  getStream(): MediaStream | null {
    return this.micStream;
  }

  toggleMute(isMuted: boolean) {
    this.micStream?.getAudioTracks().forEach(track => {
      track.enabled = !isMuted;
    });
  }
}
